import { ABC_SELECT_CUSTOM } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import ABCSelectCustomFormComponent from './index';

const module: ModulesList = {
  [ABC_SELECT_CUSTOM]: {
    path: '/abcSelect',
    component: ABCSelectCustomFormComponent,
  } as Module,
};

export default module;
